module.exports = __webpack_public_path__ + "img/gas.95234361.svg";